import { actionTypes } from './actions';

export const initialState = {
  referrerPoints: 0,
  refereePoints: 0,
  charsPerPoint: 0,
  referralBanner: {},
};

const referralConfigReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LOAD_REFERRAL_CONFIG: {
      const { referralConfig } = action;
      return {
        ...state,
        ...referralConfig,
      };
    }

    default:
      return state;
  }
};

export default referralConfigReducer;
